import classNames from "classnames";
import React, { PropsWithChildren } from "react";

type SectionWrapperProps = {
  title: React.ReactNode;
  sectionAction?: React.ReactNode;
  className?: string;
};

export const SectionWrapper = ({
  title,
  sectionAction,
  children,
  className,
}: PropsWithChildren<SectionWrapperProps>) => {
  return (
    <div
      className={classNames(
        "p-4 pb-[40px] border-b border-gray-200",
        className
      )}
    >
      <div className="flex justify-between items-center mb-4 min-h-[46px]">
        <div className="uppercase text-xs font-semibold text-grey-lightest">
          {title}
        </div>
        {sectionAction}
      </div>

      {children}
    </div>
  );
};
